<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
<span *ngIf="$.row && $.adata.fetch_key && $.adata.type=='yes-no'">{{$.row[$.adata.fetch_key] && $.row[$.adata.fetch_key]!=0 ? 'Yes':'No'}}</span>
<span *ngIf="$.row && $.adata.fetch_key && $.adata.type=='boolean'">{{$.row[$.adata.fetch_key]? 'True':'False'}}</span>
<span *ngIf="$.row && $.adata.fetch_key && $.adata.type=='checkIn'">{{$.row[$.adata.fetch_key]>0? ' Checked-in':'Checked-out'}}</span>
</ng-container>
